export const SORT_ASCENDING = 'ascending';
export const SORT_DESCENDING = 'descending';
